// extracted by css-extract-rspack-plugin
export default {"container":"MetadataContainer-module__container__YDbLz"};